import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { siteNav } from '@/mocks/siteData';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const solid = !isHome || scrolled || menuOpen;

  const linkClass = ({ isActive }: { isActive: boolean }) => {
    const base =
      'font-mono text-xs tracking-[0.16em] uppercase px-1 py-2 transition-colors whitespace-nowrap';
    if (solid) {
      return `${base} ${isActive ? 'text-primary-600' : 'text-foreground-600 hover:text-primary-600'}`;
    }
    return `${base} ${isActive ? 'text-accent-300' : 'text-background-100 hover:text-accent-300'}`;
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid
          ? 'bg-background-50/95 backdrop-blur-md border-b border-foreground-950/10'
          : 'bg-gradient-to-b from-foreground-950/70 to-transparent'
      }`}
    >
      <div className="w-full px-5 md:px-8 lg:px-12">
        <div className="flex h-16 md:h-20 items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-3 shrink-0" aria-label="深瞳爆料首页">
            <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg font-black">
              瞳
            </span>
            <span className="hidden sm:flex flex-col leading-none">
              <span
                className={`font-heading text-base md:text-lg font-bold ${
                  solid ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                深瞳爆料
              </span>
              <span
                className={`font-mono text-[10px] tracking-[0.22em] mt-1 ${
                  solid ? 'text-foreground-500' : 'text-background-200'
                }`}
              >
                SHENTONG · TIPS
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden md:flex items-center gap-7">
            {siteNav.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Link
              to="/contact"
              className="hidden sm:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-xs md:text-sm font-medium px-4 md:px-5 py-2.5 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              提交爆料
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-expanded={menuOpen}
              aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md border transition-colors cursor-pointer ${
                solid
                  ? 'border-foreground-950/15 text-foreground-900'
                  : 'border-background-50/40 text-background-50'
              }`}
            >
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen ? (
        <div className="md:hidden border-t border-foreground-950/10 bg-background-50">
          <nav aria-label="移动端导航" className="px-5 py-4 flex flex-col">
            {siteNav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `py-3.5 border-b border-foreground-950/10 font-heading text-base font-bold transition-colors ${
                    isActive ? 'text-primary-600' : 'text-foreground-950'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line"></i>
              提交爆料线索
            </Link>
          </nav>
        </div>
      ) : null}
    </header>
  );
}